import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import { generateParams } from 'features/filters/filtersSlice';
import JobseekersService from 'features/jobseekers/jobseekersService';

export const fetchJobseekersData = createAsyncThunk(
  'jobseekers/getJobseekers',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const params = generateParams(state.filters);

    try {
      const response = await JobseekersService.getJobseekers(params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
